export default __webpack_public_path__ + "static/media/main_login.4e6a5424.svg";